// src/store/getters.js
export default {
    // 检查用户是否有权限
    hasPermission: state => (permission) => {
        if (state.userinfo.role === 'admin') {
            return true;
        }
        return state.userinfo.permissions.includes(permission);
    },
    // 获取用户角色
    userRole: state => state.userinfo.role,
    // 获取用户权限列表
    userPermissions: state => state.userinfo.permissions
}
